import React, { Component } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { I18n, Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import DateFormatter from '../Common/dateFormat';
import { toFromDates } from '../Common/cleanDates';
import { ROOT_URL, companyCodeTitle, isVAK, isOLG, isLAP } from '../../actions/root_url';
import { isDst } from '../Common/NumberUtil';

momentLocalizer(moment);

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');

let renderRadios = props => {
    const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2')
    return (
      <ButtonToolbar className='radio-filter-buttons'>
        <Button bsStyle={getBsStyle(props.input.value, '1')}>
          <div className='radio'>
            <label for='today-radio-filter'>
              <input {...props.input} id='today-radio-filter' type='radio' name='dateFilterRadios' value='1' onClick={() =>{
                props.changeDays(1); 
                props.fetchReceiveHistoryByDetails(1); }} 
                checked={props.input.value === '1'}/>
              <Translate value="today" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '7')}>
          <div className='radio'>
            <label for='sevenDay-radio-filter'>
              <input {...props.input} id='sevenDay-radio-filter' type='radio' name='dateFilterRadios' value='7' onClick={() =>{ 
                props.changeDays(7);
                props.fetchReceiveHistoryByDetails(7); }} checked={props.input.value === '7'}/>
              7 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '30')}>
          <div className='radio'>
            <label for='thirtyDay-radio-filter'>
              <input {...props.input} id='thirtyDay-radio-filter' type='radio' name='dateFilterRadios' value='30' onClick={() =>{ 
                props.changeDays(30);
                props.fetchReceiveHistoryByDetails(30); }} checked={props.input.value === '30'}/>
              30 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '90')}>
          <div className='radio'>
            <label for='ninetyDay-radio-filter'>
              <input {...props.input} id='ninetyDay-radio-filter' type='radio' name='dateFilterRadios' value='90' onClick={() =>{ 
                props.changeDays(90);
                props.fetchReceiveHistoryByDetails(90); }} checked={props.input.value === '90'}/>
              90 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '-1')}>
          <div className='radio'>
            <label for='dateRange-radio-filter'>
              <input {...props.input} id='dateRange-radio-filter' type='radio' name='dateFilterRadios' value='-1' checked={props.input.value === '-1'}/>
               <Translate value="date_range" />
            </label>
          </div>
        </Button>
        <Button bsStyle='primary'>
          <Field name='FromDate' placeholder={'Start'} component={ (props.input.value === '-1') ? DatePicker : DisabledDatePicker }/>
        </Button>
        <Button bsStyle='primary'>
          <Field name='ToDate' placeholder={'End'} component={ (props.input.value === '-1') ? DatePicker : DisabledDatePicker }/>
        </Button>
        <Button
          bsStyle='primary'
          type='submit'
          onClick={() =>{ 
            props.changeDays(-1);
            props.fetchReceiveHistoryByDetails(); }}>
          <em className='fa fa-search' />
        </Button>
      </ButtonToolbar>
    )
}

class PurchasePaymentList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,

            createOpen: false,

            tableData: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },
            gourpOpen: false,
            originRows:[],
            total: 0,
            balance: 0,
            poTotal: 0,
            returnTotal: 0,
            rowsCount: 0,
            days: 7,
        };

        this.handleResize = this.handleResize.bind(this);

        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
        this.receiveDetail = this.receiveDetail.bind(this);
    }

    componentWillMount() {
      this.props.setDefaultDays('purchasePaymentList');
      this.props.fetchReceiveHistoryByDate('1900-01-01', '3000-01-01', '7', true);
    }

    componentDidMount() {
       document.title = companyCodeTitle;
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.tableData !== this.state.tableData) {
        let tableDataCurrent = Data.Selectors.getRows(this.state.tableData);
        let filterTotal = 0;
        let filterBalance = 0;
        let poTotal = 0;
        let returnTotal = 0;
        tableDataCurrent.map((item) => {
          if (item.WarehouseReceive_id) {
            filterTotal += item.FinalPrice;
            filterBalance += item.UnpaidAmount;
            poTotal += item.PurchaseFinalPrice;
            returnTotal += item.ReturnFinalPrice
          } else {
            filterTotal -= item.FinalPrice;
            filterBalance -= item.UnpaidAmount
          }      
        });
        this.setState({ rowsCount: tableDataCurrent.length, total: filterTotal.toFixed(2), balance: filterBalance.toFixed(2), poTotal: poTotal.toFixed(2), returnTotal: returnTotal.toFixed(2) });
      }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once purchaseOrders is ready, reset state.

    componentWillReceiveProps(nextProps) {
      if (!nextProps.Days) {
        this.props.setDefaultDays('purchasePaymentList');
      }
      if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory != this.props.currentReceiveHistory) {
        let receives = isVAK ? nextProps.currentReceiveHistory.Invoices.map((item, index) => ({...item, rowKeyIdx: index})) : nextProps.currentReceiveHistory.Invoices;
        const total = nextProps.currentReceiveHistory.TotalFinalPrice;
        const balance = nextProps.currentReceiveHistory.TotalBalance;
        // receives.map(
        //   receive => {
        //       receive['VendorName'] = receive.Purchase.Vendor.Name;
        //   }
        // )
        const tableData = { ...this.state.tableData, rows: receives };
        this.setState({
            tableData,
            total,
            balance,
            originRows: receives,
        });
      }
      if(nextProps.company && nextProps.company.value && nextProps.company.value != this.props.company.value
        || nextProps.warehouse && nextProps.warehouse.value && nextProps.warehouse.value != this.props.warehouse.value) {
          this.fetchReceiveHistoryByDetails(this.state.days)
      }
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    receiveDetail(e) {
      e.preventDefault();
      const currentReceiveHistory = this.state.tableData.selectedRows[0];
      this.props.resetCurrentReceiveHistory();
      this.props.selectReceiveHistory(currentReceiveHistory);
      if (isVAK && currentReceiveHistory.AP_id) {
        location.assign(`https://vakker-scm.truckxi.com/AP/${currentReceiveHistory.AP_id}`);
      } else {
        this.context.router.push('/purchasePayment/'+currentReceiveHistory.PONum);
      }
    }


    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage });
    }

    // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page

    setCurrentReceive(e) {
        e.preventDefault();
        const currentReceive = this.state.tableData.selectedRows[0];
        this.props.selectReceiveHistory(currentReceive);
    }

    clickNew(e) {
        e.preventDefault();
        // this.props.resetCurrentReceive();
        this.context.router.push('/inventories/receive/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className='alert alert-danger'>{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 930) ? 460 : 460;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.tableData);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const tableData = { ...this.state.tableData, selectedRows: rows };
                this.setState({ tableData });
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.tableData, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({ tableData: state });
            }

            const handleFilterChange = filter => {
              let newFilters = Object.assign({}, this.state.tableData.filters);
              if (filter.filterTerm) {
                  newFilters[filter.column.key] = filter;
              } else {
                  delete newFilters[filter.column.key];
              }           
              if(isVAK && (filter.column.key == 'ArrivalStatus' && I18n._locale == 'ch' || filter.column.key == 'PaymentStatus')) {
                let arrivalStatus = [{key:'Received', value: '全部收货'},{key:'Partially Received', value: '部分收货'},];
                let paymentStatus = [{key:'open', value: '未付款'},{key:'Not Paid', value: '未付款'},{key:'Credit', value: '贷款'},{key:'paid', value: '已支付'},{key:'partially paid', value: '部分支付'},{key:'Used', value: 'Used'},];
                let newRows = [];
                if(!filter.filterTerm) {
                  newRows = [...this.state.originRows];
                  const tableData = { ...this.state.tableData, rows: newRows };
                  this.setState({ tableData });
                  return 
                }
                if(filter.column.key == 'ArrivalStatus') {
                  let arrivalValue = arrivalStatus.filter(item => item.value.indexOf(filter.filterTerm) != -1);
                  this.state.originRows.map(item => {
                    arrivalValue.map(arrival => {
                      if(item.ArrivalStatus == arrival.key) {
                        newRows.push({...item});
                      }
                    })
                  })
                } else {
                  let lowerFilterTerm =  I18n._locale == 'en' &&  filter.filterTerm.toLowerCase()
                  let paymentValue = paymentStatus.filter(item => I18n._locale == 'ch' && item.value.indexOf(filter.filterTerm) != -1 || I18n._locale == 'en' && item.key.toLocaleLowerCase().indexOf(lowerFilterTerm) != -1);
                  let isHaveNotPaid = paymentValue.some(item => item.key == 'Not Paid');
                  let isHaveOpen = paymentValue.some(item => item.key == 'open');
                  let paymentValues = []
                  if(isHaveNotPaid && isHaveOpen) {
                    paymentValues = paymentValue.filter(item => item.key != 'Not Paid');
                  } else {
                    paymentValues = [...paymentValue]
                  }
                  this.state.originRows.map(item => {
                    paymentValues.map(payment => {
                      if(item.PaymentStatus == 'open' && isHaveNotPaid || item.PaymentStatus == payment.key) {
                        newRows.push({...item});
                      }
                    })
                  })
                }
                const tableData = { ...this.state.tableData, rows: newRows };
                this.setState({ tableData })
                return
              }
              const tableData = { ...this.state.tableData, filters: newFilters };
              this.setState({ tableData })
          }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className='label label-success'><Translate value="enabled" /></span>;
                    else return <span className='label label-danger'><Translate value="disable" /></span>;
                }
            });

            const onRowClick = (rowIdx, row) => {
                if(rowIdx < 0)  return;
                this.props.resetCurrentReceiveHistory();
                this.props.selectReceiveHistory(row);
                // this.context.router.push('/inventories/receive/new')
            }

            // Column difinition

            const columns = [
              {
                  key: 'PONum',
                  name: <Translate value="po_num" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
              },
              {
                  key: 'WarehouseReceiveNum',
                  name: <Translate value="receive_num" />,
                  resizable: true,
                  sortable: true,
                  width: 105,
                  filterable: true,
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="po_date" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
                  formatter: DateFormatter,
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="posting_date" />,
                  resizable: true,
                  sortable: true,
                  width: 130,
                  filterable: true,
                  formatter: DateFormatter,
              },
              {
                  key: 'InvoiceNum',
                  name: <Translate value="invoice_no" />,
                  resizable: true,
                  sortable: true,
                  width: 110,
                  filterable: true,
              },
              {
                  key: 'VendorName',
                  name: <Translate value="vendor_name" />,
                  resizable: true,
                  sortable: true,
                  width: 190,
                  filterable: true,
              },
              ...isLAP ? [
                {
                  key: 'PurchaseFinalPrice',
                  name: <Translate value="po_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
                  formatter: CashFormatter,
                },
              ]:[],
              {
                  key: 'FinalPrice',
                  name: <Translate value={isVAK ? "final_dollar" : isLAP ? "receive_dollarsign" : "final_dollarsign"} />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
                  formatter: CashFormatter,
              },
              ...isLAP ? [
                {
                  key: 'ReturnFinalPrice',
                  name: <Translate value="return_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true,
                  formatter: CashFormatter,
                },
              ]:[],
              ...!isLAP ? [
                {
                  key: 'UnpaidAmount',
                  name: <Translate value="balance" />,
                  resizable: true,
                  sortable: true,
                  width: 75,
                  filterable: true,
                  formatter: CashFormatter,
              },
              ]:[],
              {
                  key: 'Create_Username',
                  name: <Translate value="purchaser" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'ArrivalStatus',
                  name: <Translate value="status" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: ({ value }) => (
                    <div>
                      <Translate value={value} />
                    </div>
                  ),
              },
              {
                  key: 'PaymentStatus',
                  name: <Translate value="pmt_status" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: ({ value }) => (
                    <div>
                      <Translate value={value === 'open' ? 'not_paid' : value} />
                    </div>
                  ),
              },
              ...isLAP ? [
                {
                  key: 'UnpaidAmount',
                  name: <Translate value="balance" />,
                  resizable: true,
                  sortable: true,
                  width: 75,
                  filterable: true,
                  formatter: CashFormatter,
                },
              ]:[],
              {
                  key: 'CheckNum',
                  name: <Translate value="check_num" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
              },
              {
                  key: 'Note',
                  name: <Translate value="note" />,
                  resizable: true,
                  sortable: true,
                  width: 95,
                  filterable: true,
              },
              {
                  key: 'Owner',
                  name: <Translate value="owner" />,
                  resizable: true,
                  sortable: true,
                  width: 95,
                  filterable: true,
              },
            ]

            return (
                //React Table Purchase Payment List
              <div>
                <Row>
                  <Col xs={ 12 }>
                    <div id="PurchasePaymentList-dataGrid1">
                      <ReactDataGrid
                        rowKey={isVAK ? 'rowKeyIdx' : 'WarehouseReceive_id'}
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        headerRowHeight={45}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowClick={onRowClick}
                        onRowSelect={onRowSelect}
                        />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={ 12 }> 
                    <div>
                      <Col xs={isLAP ? 1 : 3}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px' }}>
                          <Translate value="rows" />:&nbsp;
                          <span className="font-color-orange">{ this.state.rowsCount }</span>
                        </label>
                      </Col>
                      {
                        isLAP &&  
                        <Col className="col-sm-2" style={{ width: '280px' }}>
                          <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                            <span style={{ 'margin-top': '3px' }}>
                              <Translate value="po_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                            </span>
                            <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.poTotal)}` || 0}/>
                          </label>
                        </Col>
                      }
                      <Col className="col-sm-2" style={{ width: '280px' }}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                          <span style={{ 'margin-top': '3px' }}>
                            <Translate value={isLAP ? "receive_total" : "final_total"} /><span className="dollar-sign"> $$</span>:&nbsp;
                          </span>
                          <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.total)}` || 0}/>
                        </label>
                      </Col>
                      {
                        isLAP &&  
                        <Col className="col-sm-2" style={{ width: '280px' }}>
                          <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                            <span style={{ 'margin-top': '3px' }}>
                              <Translate value="return_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                            </span>
                            <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.returnTotal)}` || 0}/>
                          </label>
                        </Col>
                      }
                      <Col xs={isLAP ? 3 : 4}>
                        <label style={{ 'display': 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                          <span style={{ 'margin-top': '3px' }}>
                            <Translate value="balance_total" /><span className="dollar-sign"> $$</span>:&nbsp;
                          </span>
                          <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.balance)}` || 0}/>
                        </label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </div>
            )
        }
    }

    renderDatePickers() {
      if(this.props.Days == -1)
        return (
          <div className='form-group date-picker-positioner'>
            <label className='col-xs-2 from-label col-xs-offset-5'>
              <Translate value="from" />
            </label>
            <div className='col-xs-2 control-date-picker'>
              <Field name='FromDate' component={DatePicker} disabled={this.props.Days !== '-1'} />
            </div>
            <label className='col-xs-1 to-label'>
              <Translate value="to" />
            </label>
            <div className='col-xs-2 control-date-picker'>
              <Field name='ToDate' component={DatePicker} disabled={this.props.Days !== '-1'} />
            </div>
          </div>
        )
      // else return(
      //   <Row>
      //     <Col xs={ 10 }></Col>
      //     <Col xs={ 2 }>
      //       <Button
      //         bsStyle='primary'
      //         onClick={() =>{ this.fetchReceiveHistoryByDetails(); }}><Translate value="submit" />
      //       </Button>
      //     </Col>
      //   </Row>
      // )
    }

    fetchReceiveHistoryByDetails(days) {
      let dateRange = -1;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';

      if (this.props.FromDate != null)
        FromDate = this.formatDate(this.props.FromDate);

      if (this.props.ToDate != null)
        ToDate = this.formatDate(this.props.ToDate);
      if (days != null) {
        dateRange = days;
      }
      this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange, true);
    }

    changeDays(days) {
      this.setState({days: days})
    }

    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }

      return formattedDate;
    }

    renderPrint() {
      let warehouseReceiveNum = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length == 1 && this.state.tableData.selectedRows[0].WarehouseReceiveNum;
      const warehouseReceiveID = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
      if (!warehouseReceiveNum || !warehouseReceiveID) {
        return;
      }
      let url = ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceiveNum + '?Bearer=' + localStorage.getItem('token');
      if(isOLG) {
        let sq = new Date().getTimezoneOffset();
        let time = -sq / 60;
        if(sq > 0 && isDst()) {
          sq+=60;
          let zone = -sq / 60;
          url += `&time_zone=${zone}&time_diff=${time}`;
        } else {
          url += `&time_zone=${(time)}&time_diff=${time}`;
        }
      }
      return(
        <Button
          bsStyle='primary'
          type='button'
          href={url}>
          <em className='fa fa-print' /><Translate value="print" />
        </Button>
      )
    }

    getDateFromFilter() {
      const { FromDate, ToDate, Days } = this.props;
      // let fromDate = FromDate ? moment(FromDate).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
      // let toDate = ToDate ? moment(ToDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      let fromDate;
      let toDate;
      if (Days !== '-1') {
        fromDate = moment().subtract(parseInt(Days, 10), 'days').format('YYYY-MM-DD');
        toDate = moment().format('YYYY-MM-DD');
      } else {
        fromDate = FromDate ? moment(FromDate).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
        toDate = ToDate ? moment(ToDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      }
      return { fromDate, toDate };
    }

    renderExportButton() {
      const { FromDate, ToDate, Days, warehouse  } = this.props;
      const dates = toFromDates(Days, FromDate, ToDate);
      const fromDate = `startdate=${dates.fromDate}`;
      const toDate = `enddate=${dates.toDate}`;
      const token = `Bearer=${localStorage.getItem('token')}`;
      const warehouse_id = `warehouse_id=${warehouse.value}`
      let url = `${ROOT_URL}v1/dashboard/purchasecsv/?${fromDate}&${toDate}&${token}`;
      if (isLAP) {
        url += `&${warehouse_id}`
      }
      return (
        <Button
          bsStyle='success'
          type='button'
          href={url}
        >
          <em className='fa fa-download' /><Translate value="export" />
        </Button>
      );
    }

    render() {
        let createDialogStyle = {
            width: '400px',
            marginLeft: '-10%',
        };
        let warehouseReceive_id = this.state.tableData.selectedRows && this.state.tableData.selectedRows[0] && this.state.tableData.selectedRows[0].WarehouseReceive_id;
        warehouseReceive_id = warehouseReceive_id || '';
        let url = ROOT_URL + 'v1/warehouse/receive/print/' + warehouseReceive_id + '?Bearer=' + localStorage.getItem('token');
        let height = (this.state.tableHeight + 70).toString();
        let tableCollapseFix = {height: height}
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="ar_slashsign_ap" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active='true'>
                  <Translate value="purchase_report" />
                </Breadcrumb.Item>
              </Breadcrumb>

              <ButtonToolbar>
                { this.renderExportButton() }
              </ButtonToolbar>

              <Grid id='purchase-payment'>
                {/* <h1><Translate value="purchase_report" /></h1> */}
                <Row>
                  <Col xs={ 12 }>
                    <Panel id='date-range-picker' className='form-horizontal'>
                      <Row>
                        <Col xs={ 1 }>
                          <h3 className='filter-title text-nowrap'><Translate value="posting_date" /><span className='colon'>:</span></h3>
                        </Col>
                        <Col xs={ 11 }>
                          <Field name='Days' component={ renderRadios } fetchReceiveHistoryByDetails={this.fetchReceiveHistoryByDetails.bind(this)} changeDays={this.changeDays.bind(this)} />
                        </Col>
                      </Row>
                    </Panel>
                  </Col>
                </Row>

                <Row>
                  <Col xs={ 12 }>
                    <Panel className='position-relative table-collapse-fix'>
                      <ButtonToolbar className='table-buttons'>
                        <Button
                          bsStyle='primary'
                          disabled={!this.state.tableData.selectedRows || this.state.tableData.selectedRows.length != 1}
                          onClick={this.receiveDetail}>
                          <em className='fa fa-file-text' />
                          <Translate value="detail" />
                        </Button>
                        {this.renderPrint()}
                      </ButtonToolbar>
                      {this.renderTable() }
                    </Panel>
                  </Col>
                </Row>
              </Grid>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------

        );
    }
}



export default PurchasePaymentList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePaymentList.jsx